import { useRef, useEffect, useState } from "react";

const features = [
  { icon:"🪚", title:"Carpenter Management",  desc:"Add and manage multiple carpenters. Each gets their own dashboard to track their team.", bg:"#FEF3C7", tc:"#D97706" },
  { icon:"🔨", title:"Labour Tracking",        desc:"Track every labour under each carpenter — attendance, payments, salary all in one place.", bg:"#E0F2FE", tc:"#0369A1" },
  { icon:"📅", title:"Smart Attendance",       desc:"Mark Full Day, Half Day, Overtime, Absent, Holiday or Leave with a visual colour-coded calendar.", bg:"#D1FAE5", tc:"#059669" },
  { icon:"💰", title:"Salary & Payments",      desc:"Auto-calculate salary with overtime support. Record advances and generate detailed breakdowns.", bg:"#EDE9FE", tc:"#7C3AED" },
  { icon:"📄", title:"PDF Reports",            desc:"Export professional attendance & payment reports as PDF — shareable anytime, anywhere.", bg:"#FEF3C7", tc:"#D97706" },
  { icon:"🛡️", title:"Role-Based Access",      desc:"Admin, Carpenter, and Labour — each role sees only what they need. Secure and structured.", bg:"#E0F2FE", tc:"#0369A1" },
];

export default function Features() {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVis(true); }, { threshold:.12 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ padding:"88px 5vw", background:"#FAF7F4" }}>
      <div style={{ maxWidth:"1200px", margin:"0 auto" }}>

        {/* Header */}
        <div style={{ opacity:vis?1:0, transform:vis?"translateY(0)":"translateY(28px)", transition:"all .6s ease" }}>
          <p style={{ fontSize:"11px", fontWeight:800, color:"#D97706", letterSpacing:"1.5px", textTransform:"uppercase", marginBottom:"10px" }}>Features</p>
          <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(28px,4vw,44px)", fontWeight:900, color:"#1C1917", lineHeight:1.15, marginBottom:"14px" }}>
            Everything you need to<br/>run your team
          </h2>
          <p style={{ fontSize:"16px", color:"#78716C", lineHeight:1.6, maxWidth:"500px" }}>
            From daily attendance to final salary — Craftigo covers the full workflow for construction teams.
          </p>
        </div>

        {/* Grid */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:"16px", marginTop:"48px" }}>
          {features.map((f, i) => (
            <div
              key={f.title}
              style={{
                padding:"24px", borderRadius:"18px", background:"#fff",
                border:"1.5px solid #E7E5E4", transition:"all .2s",
                opacity:vis?1:0, transform:vis?"translateY(0)":"translateY(28px)",
                transitionDelay:`${i*0.07}s`, transitionDuration:".55s",
                cursor:"default",
              }}
              onMouseEnter={e => { e.currentTarget.style.transform="translateY(-4px)"; e.currentTarget.style.boxShadow="0 14px 40px rgba(0,0,0,.07)"; e.currentTarget.style.borderColor="#FDE68A"; }}
              onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="none"; e.currentTarget.style.borderColor="#E7E5E4"; }}>
              <div style={{ width:"48px", height:"48px", borderRadius:"12px", background:f.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"22px", marginBottom:"16px" }}>
                {f.icon}
              </div>
              <p style={{ fontSize:"16px", fontWeight:800, color:"#1C1917", marginBottom:"8px" }}>{f.title}</p>
              <p style={{ fontSize:"14px", color:"#78716C", lineHeight:1.6 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}